import { Component, OnInit } from '@angular/core';
import {Meta, Title} from '@angular/platform-browser';

declare var $: any;
declare var toastr: any;
declare var document: any;

@Component({
  selector: 'app-estimate',
  templateUrl: './estimate.component.html',
  styleUrls: ['./estimate.component.css']
})
export class EstimateComponent implements OnInit {
  calculatorType = '1';
  startingPriceWeb = 300;
  typeWeb = 1;
  sizeWeb = 1;
  featureWeb = 0;
  adFeatureWeb = 0;
  webPrice = 0;

  mpTypeWeb = 2000;
  mpSizeWeb = 1;
  mpFeatureWeb = 0;
  adMpFeatureWeb = 0;
  mpPrice = 0;


  maType = 200;
  maPurpose = 3;
  maService = 1;
  maSize = 1;
  adMpFeature = 0;
  maPrice = 0;

  webAppType = 2000;
  webAppProduct = 1;
  webAppFeature = 0;
  webAppIntegration = 0;
  webAppPrice = 0;
  showCost = 0;
  constructor(private meta: Meta, private title: Title) {
    document.body.scrollTop = 0;
  }
  ngOnInit(): void {
    this.title.setTitle('IrvineTek | Let’s Uncover Tech Potential For Your Business');
    // Google / Search Engine Tags
    this.meta.updateTag({ property: 'name', content: 'IrvineTek | Let’s Uncover Tech Potential For Your Business' });
    this.meta.updateTag({ property: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Facebook Meta Tags
    this.meta.updateTag({ property: 'og:url', content: 'https://irvinetek.com/' });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:title', name: 'title', content: 'IrvineTek | Let’s Uncover Tech Potential For Your Business' });
    this.meta.updateTag({ property: 'og:description', name: 'description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'og:image', name: 'image', content: 'https://irvinetek.com/assets/images/logo.png' });
    // Twitter Meta Tags
    this.meta.updateTag({ property: 'twitter:card', content: 'summary_large_image' });
    this.meta.updateTag({ property: 'twitter:title', content: 'IrvineTek | Let’s Uncover Tech Potential For Your Business' });
    this.meta.updateTag({ property: 'twitter:description', content: 'IrvineTek provides affordable software development & consulting services for web & mobile apps in Python, PHP, Angular, React, Kotlin, Swift & other frameworks.' });
    this.meta.updateTag({ property: 'twitter:image', content: 'https://irvinetek.com/assets/images/logo.png' });

    $('.services-slider').owlCarousel({
      dots: true,
      dotData: true,
      autoplay: false,
      lazyLoad: true,
      loop: false,
      responsiveClass: true,
      autoHeight: true,
      autoplayTimeout: 7000,
      smartSpeed: 800,
      nav: false,
      responsive: {
        0: {
          items: 2,
        },
        600: {
          items: 3,
        },
        800: {
          items: 4,
        },
        1000: {
          items: 5,
        }
      }
    });
    this.calculateWebPrice();
  }
  changeTabs(event): void {
    $('.services-slider .nav-link').removeClass('active');
    $(event.target).addClass('active123');
  }
  changeTabsInd(event): void {
    $('.industries-slider .nav-link').removeClass('active');
    $(event.target).addClass('active123');
  }

  changeCalculatorType(): any{
    this.startingPriceWeb = 300;
    this.typeWeb = 1;
    this.sizeWeb = 1;
    this.featureWeb = 0;
    this.adFeatureWeb = 0;
    this.webPrice = 0;

    this.mpTypeWeb = 2000;
    this.mpSizeWeb = 1;
    this.mpFeatureWeb = 0;
    this.adMpFeatureWeb = 0;
    this.mpPrice = 0;

    this.maType = 200;
    this.maPurpose = 3;
    this.maService = 1;
    this.maSize = 1;
    this.adMpFeature = 0;
    this.maPrice = 0;


    this.webAppType = 2000;
    this.webAppProduct = 1;
    this.webAppFeature = 0;
    this.webAppIntegration = 0;
    this.webAppPrice = 0;

    if ( this.calculatorType === '1' ) {
      this.calculateWebPrice();
    }
    if ( this.calculatorType === '2' ) {
      this.calculateMpWebPrice();
    }
    if ( this.calculatorType === '3' ) {
      this.calculateAppPrice();
    }
    if ( this.calculatorType === '4' ) {
      this.calculateWebAppPrice();
    }
    this.showCost = 0;
  }


  updateTypeWeb(event): any{
    this.typeWeb = Number(event);
    this.calculateWebPrice();
  }
  updateSizeWeb(event): any{
    this.sizeWeb = Number(event);
    this.calculateWebPrice();
  }
  featuresWeb(target): any{
    if ( target.checked === true ) {
      this.featureWeb = this.featureWeb + Number(target.value);
    } else {
      this.featureWeb = this.featureWeb - Number(target.value);
    }
    this.calculateWebPrice();
  }
  adFeaturesWeb(target): any{
    if ( target.checked === true ) {
      this.adFeatureWeb = this.adFeatureWeb + Number(target.value);
    } else {
      this.adFeatureWeb = this.adFeatureWeb - Number(target.value);
    }
    this.calculateWebPrice();
  }
  calculateWebPrice(): any{
    this.webPrice = ( this.startingPriceWeb * this.typeWeb * this.sizeWeb ) + this.featureWeb + this.adFeatureWeb;
    this.webPrice = this.roundToNearestThousand(this.webPrice*3);
    if ( this.showCost === 2 ) {
      this.showCost = 1;
    }
  }


  updateMpTypeWeb(event): any{
    this.mpTypeWeb = Number(event);
    this.calculateMpWebPrice();
  }
  updateMpSizeWeb(event): any{
    this.mpSizeWeb = Number(event);
    this.calculateMpWebPrice();
  }
  featuresMpWeb(target): any{
    if ( target.checked === true ) {
      this.mpFeatureWeb = this.mpFeatureWeb + Number(target.value);
    } else {
      this.mpFeatureWeb = this.mpFeatureWeb - Number(target.value);
    }
    this.calculateMpWebPrice();
  }
  adFeaturesMpWeb(target): any{
    if ( target.checked === true ) {
      this.adMpFeatureWeb = this.adMpFeatureWeb + Number(target.value);
    } else {
      this.adMpFeatureWeb = this.adMpFeatureWeb - Number(target.value);
    }
    this.calculateMpWebPrice();
  }
  calculateMpWebPrice(): any{
    this.mpPrice = ( this.mpTypeWeb *  this.mpSizeWeb ) + this.mpFeatureWeb + this.adMpFeatureWeb;
    this.mpPrice = this.roundToNearestThousand(this.mpPrice*3);
    if ( this.showCost === 2 ) {
      this.showCost = 1;
    }
  }
  roundToNearestThousand(num) {
    // Calculate the nearest thousand
    return Math.ceil(num / 1000) * 1000;
  }



  updateMaType(event): any{
    this.maType = Number(event);
    this.calculateAppPrice();
  }
  updatePurposeApp(event): any{
    this.maPurpose = Number(event);
    this.calculateAppPrice();
  }
  updateServiceApp(event): any{
    this.maService = Number(event);
    this.calculateAppPrice();
  }
  updateMpSizeApp(event): any{
    this.maSize = Number(event);
    this.calculateAppPrice();
  }
  adFeaturesApp(target): any{
    if ( target.checked === true ) {
      this.adMpFeature = this.adMpFeature + Number(target.value);
    } else {
      this.adMpFeature = this.adMpFeature - Number(target.value);
    }
    this.calculateAppPrice();
  }
  calculateAppPrice(): any{
    this.maPrice = ( this.maType *  this.maPurpose * this.maService * this.maSize ) + this.adMpFeature;
    if ( this.showCost === 2 ) {
      this.showCost = 1;
    }
  }


  updateUpdateWebApp(event): any{
    this.webAppType = Number(event);
    this.calculateWebAppPrice();
  }
  updateWebAppProduct(event): any{
    this.webAppProduct = Number(event);
    this.calculateWebAppPrice();
  }
  integrationWebApp(target): any{
    if ( target.checked === true ) {
      this.webAppIntegration = this.webAppIntegration + Number(target.value);
    } else {
      this.webAppIntegration = this.webAppIntegration - Number(target.value);
    }
    this.calculateWebAppPrice();
  }
  featuresWebApp(target): any{
    if ( target.checked === true ) {
      this.webAppFeature = this.webAppFeature + Number(target.value);
    } else {
      this.webAppFeature = this.webAppFeature - Number(target.value);
    }
    this.calculateWebAppPrice();
  }
  calculateWebAppPrice(): any{
    this.webAppPrice = this.webAppType +  this.webAppIntegration;
    if ( this.webAppProduct > 0 ) {
      this.webAppPrice = this.webAppPrice * this.webAppProduct;
    }
    if ( this.webAppFeature > 0 ) {
      this.webAppPrice = this.webAppPrice * this.webAppFeature;
    }
    this.webAppPrice = this.roundToNearestThousand(this.webAppPrice*3);
    if ( this.showCost === 2 ) {
      this.showCost = 1;
    }
  }
  submitCost(): any{
    this.showCost = 2;
  }
}
